import { RuleBoard } from '../../Components/Quiz/Rule';
import React from 'react';
export const RulePage:React.FC = () =>{
  return(

    <div className= "content flex">
      <RuleBoard />

    </div>
  )
}